import React from 'react'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { useCreateSalesTaxTemplateMutation, useGetSalesTaxTemplateByNameQuery, useUpdateSalesTaxTemplateMutation } from '../../../../store/api/Salestaxes';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Attachment from '../../../../utils/Attachment';
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
function Tax() {
    const location = useLocation()
    const salestaxId = location?.state?.taxId
    const navigate = useNavigate()
    // const [tab, settab] = useState(1)
    // const [taxes, setTaxes] = useState([])
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [createSalesTax] = useCreateSalesTaxTemplateMutation();
    const { data, isLoading, isError } = useGetSalesTaxTemplateByNameQuery(salestaxId);
    const [updateTemplate] = useUpdateSalesTaxTemplateMutation();
    const [compname, setname] = useState('')
    const pageStateDefault = {
           tab: 1,
           title: "",
           taxcategory: "",
           company: "",
           defaults: false,
           disabled: false,
           taxes:[{  charge_type: "",
           account_head: "",
           rate: "",
           tax_amount: "",
           description: ""}],
       
         };
       
         const [pageState, setPageState] = usePageState(`Edit Sales Taxes and Charges Template - ${salestaxId}`, pageStateDefault);
       
       
         const { tab, title, taxcategory, company, defaults, disabled, taxes } = pageState;

    const [detaildata, setDetaildata] = useState([])
    useEffect(() => {
         if (!isStateChanged(pageState, pageStateDefault)) {
        if (data?.data) {
            const { title, tax_category, company, is_default, disabled } = data.data
            // setDetaildata(data.data.taxes)
            setPageState({
                title: title || "",
                taxcategory: tax_category || "",
                company: company || "",
                default: Boolean(is_default),
                disabled: Boolean(disabled),
                taxes:data.data.taxes
            })

        }
    }

    }, [data])
    useEffect(() => {
        if (pageState.company) {
            setname(pageState.company);
        }
    }, [pageState.company]);

    const handlechange = (e) => {
        const { name, value } = e.target;
        setPageState((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const handleSubmit = async () => {
        const payload = { title: pageState.title, company: pageState.company, tax_category: pageState.taxcategory, is_default: pageState.default, disabled: pageState.disabled, taxes: taxes };
        try {
            const res = await updateTemplate({
                name: salestaxId,
                payload
            }).unwrap();
            setError('Sales Taxes and Charges Template updated successfully!');
            setptype('Success');
            setShowError(true);
            setTimeout(() => {
                navigate('/master/tax/tax-list')
            }, 3000);
        } catch (error) {
            const parsedMessages = JSON.parse(error.data._server_messages);
            const firstMessageObj = JSON.parse(parsedMessages[0]);
            console.log(firstMessageObj, "errr");
            setError(firstMessageObj.message);
            setptype('Error');
            setptype('Error');
            setShowError(true);
        }
    };

     const handleInputChange = (fieldName, value) => {
        setPageState(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };
    return (
        <>
            <FormLayoutTwo
                title="Edit Sales Taxes and Charges Template"
                breadcrumbs={[
                    { label: " Taxes and Charges Template" },
                    { label: " Taxes and Charges Template List", url: "/master/tax/tax-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>
              
                        <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            onClick={handleSubmit}
                            iconSize={12}
                        >Update
                        </Button>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { setPageState({ ...pageState, tab: 1 }) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                             <Attachment doctype="Sales Taxes and Charges Template"  docname={salestaxId}  /> 
                        </div>
                    </div>

     <div className=" " style={{ background: '' }}>
                    <div className="row">
                      <div className="col-12">
                        <div >
                          <Tab1
                          
                           pageState={pageState}
								  setPageState={setPageState}
handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
  onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                    taxes={{
  value: pageState.taxes || [],
  setValue: (val) =>
    setPageState({
      ...pageState,
      taxes: val,
    }),
}} compname={compname} 
                          
                          salestaxId={salestaxId}/>
                        </div>
                      </div>
                    </div>
                  </div> 
                    
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    )
}

export default Tax
